<div class="container">
  <mat-accordion class="example-headers-align">

    <mat-expansion-panel  *ngIf="rol !=='Almacenista'" [expanded]="expandedAdminData.jobTitle">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">CARGOS</mat-panel-title>
      </mat-expansion-panel-header>
      <data-table
        title
        [columns]="columnsJobTitle"
        [configuration]="configurationJobTitle"
        (add)="addJobTitle($event)"
        (edit)="editJobTitle($event)"
        (delete)="deleteJobTitle($event)"
        [params]="[]"
        [url]="urlGetDatosJobTitle"
        [reloadTable]="reloadJobTitleTable"
      ></data-table>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="rol !=='Almacenista'" [expanded]="expandedAdminData.areas">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">Áreas</mat-panel-title>
      </mat-expansion-panel-header>
      <data-table
      title
      [columns]='columnsAreas'
      [configuration]='configurationAreas'
      [reloadTable]='reloadAreasTable'
      (add)='addAreas($event)'
      (edit)='editAreas($event)'
      (delete)='deleteAreas($event)'
      [params]='[]'
      [url]='urlGetDatosAreas'
      ></data-table>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="inventoryModule" [expanded]="expandedAdminData.itemInventory">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">Item Inventario</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="container-toggle">
        <mat-slide-toggle class="toggle" (change)="changeToggle($event)" [(ngModel)]="isChecked">{{labelToggle}}</mat-slide-toggle>
      </div>
      <data-table
      *ngIf="isChecked"
      [title]='"Items Activos"'
      [columns]='columnsItem'
      [configuration]='configurationItem'
      [reloadTable]='reloadItemTable'
      (active)="inactivateOrActiveItems ($event, false)"
      (add)='addItem($event)'
      (edit)='editItem($event)'
      [params]='paramsItem'
      [url]='urlGetDataItem'
      ></data-table>

      <data-table
      *ngIf="!isChecked"
      [title]='"Items Inactivos"'
      [columns]='columnsItem'
      [configuration]='configurationItemInactive'
      [reloadTable]='reloadItemInactiveTable'
      (active)="inactivateOrActiveItems ($event, true)"
      [params]='paramsItem2'
      [url]='urlGetDataItem'
      ></data-table>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="rol !=='Almacenista'" [expanded]="expandedAdminData.equipmentTipe">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">Tipo Equipos</mat-panel-title>
      </mat-expansion-panel-header>
      <data-table
        title
        [columns]="columnsEquipmentType"
        [configuration]="configurationEquipmentType"
        (add)="addEquipmentType($event)"
        (edit)="editEquipmentType($event)"
        (delete)="deleteEquipmentType($event)"
        [params]="[]"
        [url]="urlGetDatosTipoEquipo"
        [reloadTable]="reloadEquipmentTypeTable"
      ></data-table>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="rol !=='Almacenista'" [expanded]="expandedAdminData.frequentActivities">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">Actividades frecuentes</mat-panel-title>
      </mat-expansion-panel-header>
      <data-table
        title
        [columns]="columnsFrequentActivities"
        [configuration]="configurationFrequentActivities"
        (add)="addFrequentActivities($event)"
        (edit)="editFrequentActivities($event)"
        (delete)="deleteFrequentActivities($event)"
        [params]="[]"
        [url]="urlGetDatosActividadesFrecuentes"
        [reloadTable]="reloadFrequentActivitiesTable"
      ></data-table>
    </mat-expansion-panel>
    
  </mat-accordion>
</div>
